/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Ad_Template_NameInputs */

const en_ad_template_name = /** @type {(inputs: Ad_Template_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AD Template 0${i?.index}`)
};

const fr_ad_template_name = /** @type {(inputs: Ad_Template_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Modèle AD 0${i?.index}`)
};

const de_ad_template_name = /** @type {(inputs: Ad_Template_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AD-Vorlage 0${i?.index}`)
};

const it_ad_template_name = /** @type {(inputs: Ad_Template_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Modello di annuncio 0${i?.index}`)
};

const ru_ad_template_name = /** @type {(inputs: Ad_Template_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Шаблон объявления 0${i?.index}`)
};

const es_ad_template_name = /** @type {(inputs: Ad_Template_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plantilla de anuncio 0${i?.index}`)
};

const zh_cn2_ad_template_name = /** @type {(inputs: Ad_Template_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`广告模板 0${i?.index}`)
};

const ja_ad_template_name = /** @type {(inputs: Ad_Template_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`広告テンプレート 0${i?.index}`)
};

const hi_ad_template_name = /** @type {(inputs: Ad_Template_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AD टेम्पलेट 0${i?.index}`)
};

const pt_pt2_ad_template_name = /** @type {(inputs: Ad_Template_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Modelo de anúncio 0${i?.index}`)
};

/**
* | output |
* | --- |
* | "AD Template 0{index}" |
*
* @param {Ad_Template_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_template_name = /** @type {((inputs: Ad_Template_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Template_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_template_name(inputs)
	if (locale === "de") return de_ad_template_name(inputs)
	if (locale === "it") return it_ad_template_name(inputs)
	if (locale === "ru") return ru_ad_template_name(inputs)
	if (locale === "es") return es_ad_template_name(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_template_name(inputs)
	if (locale === "ja") return ja_ad_template_name(inputs)
	if (locale === "hi") return hi_ad_template_name(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_template_name(inputs)
	return en_ad_template_name(inputs)
});